import React from 'react';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import styles from './CurrencyDisclaimer.module.scss';
import classnames from 'classnames';

export const CurrencyDisclaimer = ({ text, toggleCurrencyWarning }) => {
  return (
    <div
      className={classnames(styles.currencyDisclaimer, toggleCurrencyWarning ? styles.clickable : null)}
      onClick={toggleCurrencyWarning}
    >
      <GenerateIcon className={styles.currencyConversionIcon} iconName={ICONS.circleInfo.name} />
      <div className={styles.currencyConversionText}>{text}</div>
    </div>
  );
};
